import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const links = [
  { to: "/", label: "Home" },
  { to: "/booking", label: "Book" },
  { to: "/affirmations", label: "Affirmations" },
  { to: "/about", label: "About" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#F7F5F2]/85 backdrop-blur-xl border-b border-[#D8D4CC]"
          : "bg-transparent"
      }`}
    >
      <div className="px-6 md:px-12 lg:px-20 py-5 md:py-6 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-link"
          className="flex items-baseline gap-2 group"
        >
          <span className="font-serif-display text-2xl md:text-[28px] tracking-tight text-[#1A1A1A]">
            Finka
          </span>
          <span className="font-eyebrow text-[10px] text-[#5C5C59] hidden sm:inline">
            Wholistic Wellness
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-eyebrow text-[11px] transition-colors duration-300 ${
                  isActive
                    ? "text-[#1A1A1A]"
                    : "text-[#5C5C59] hover:text-[#1A1A1A]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/booking"
            data-testid="nav-book-cta"
            className="font-eyebrow text-[11px] px-5 py-3 bg-[#1A1A1A] text-[#F7F5F2] hover:bg-[#42493D] transition-colors duration-300"
          >
            Book a Session
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden font-eyebrow text-[11px] text-[#1A1A1A]"
          aria-label="Toggle menu"
        >
          {open ? "Close" : "Menu"}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#D8D4CC] bg-[#F7F5F2]">
          <div className="flex flex-col px-6 py-6 gap-5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                className="font-eyebrow text-xs text-[#1A1A1A]"
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/booking"
              data-testid="mobile-nav-book-cta"
              className="font-eyebrow text-[11px] px-5 py-3 bg-[#1A1A1A] text-[#F7F5F2] inline-block w-fit"
            >
              Book a Session
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
